import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SpacesService } from '../../services/spaces.service';
import { ModalService } from '../../services/modal.service';
import { Space, Note } from '../../models/space.model';

@Component({
  selector: 'app-notes',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './notes.component.html',
  styleUrl: './notes.component.scss'
})
export class NotesComponent implements OnInit {
  @Input() visible = false;

  space: Space | null = null;
  notesExpanded = false;
  editingIndex: number | null = null;
  editingText = '';
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private readonly spacesService: SpacesService,
    private readonly modalService: ModalService
  ) {}

  ngOnInit(): void {
    this.spacesService.activeSpace$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((space) => {
      this.space = space;
    });
  }

  get hasNotes(): boolean {
    return (this.space?.notes && this.space.notes.length > 0) || false;
  }

  toggleNotesExpanded(): void {
    this.notesExpanded = !this.notesExpanded;
  }

  addNote(): void {
    if (this.space) {
      this.modalService.openAddNoteModal(this.space.id);
    }
  }

  startInlineEdit(note: Note, index: number): void {
    this.editingIndex = index;
    this.editingText = note.text;
  }

  saveInlineEdit(index: number): void {
    if (!this.space || !this.editingText.trim()) return;
    this.spacesService.updateNote(this.space.id, index, this.editingText.trim());
    this.editingIndex = null;
    this.editingText = '';
  }

  cancelInlineEdit(): void {
    this.editingIndex = null;
    this.editingText = '';
  }

  deleteNote(index: number): void {
    if (this.space) {
      this.spacesService.deleteNote(this.space.id, index);
    }
  }
}
